import React, { useEffect, useState, useRef } from 'react'
import { makeStyles, createStyles, Box, fade, useTheme, useMediaQuery, Divider } from '@material-ui/core'
import { DATE_FORMAT, LATER_DISABLE_DAYS, AVAILABLE_MONTHS } from 'src/utils/constant'
import subDays from 'date-fns/subDays'
import subMonths from 'date-fns/subMonths'
import eachDayOfInterval from 'date-fns/eachDayOfInterval'
import format from 'date-fns/format'
import getMonth from 'date-fns/getMonth'
import getDate from 'date-fns/getDate'
import getDay from 'date-fns/getDay'
// import DatePicker from './DatePicker'
import DatePicker2 from './DatePicker2'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { getAllTime } from 'src/store/slices/testCenterSlice'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      // paddingTop: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      borderBottomColor: theme.palette.assistant.assistant05,
      borderBottomWidth: theme.spacing(1),
      borderBottomStyle: 'solid',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    clinicInfo: {
      borderBottom: `1px solid ${theme.palette.grey[50]}`,
      margin: theme.spacing(0, 2),
      paddingBottom: theme.spacing(1.5),
    },
    chip: {
      flexDirection: 'row-reverse',
    },
    location: {
      display: 'flex',
      alignItems: 'center',
      color: fade(theme.palette.grey[900], 0.65),
      '& svg': {
        width: theme.spacing(1.5),
        height: theme.spacing(1.5),
      },
      '& path': {
        fill: fade(theme.palette.grey[900], 0.65),
      },
    },
    listWrapper: {
      position: 'relative',
      [theme.breakpoints.down('xs')]: {
        paddingTop: theme.spacing(1.5),
      },
    },
    list: {
      display: 'flex',
      overflowX: 'auto',
      paddingBottom: theme.spacing(2),
      marginLeft: theme.spacing(1),
    },
    segmentLabelWrapper: {
      position: 'absolute',
      bottom: theme.spacing(2),
      zIndex: 2,
      left: theme.spacing(-1),
    },
    segmentLabel: {
      width: theme.spacing(1),
      height: theme.spacing(4.75),
      color: fade(theme.palette.grey[900], 0.45),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      marginBottom: theme.spacing(0.75),
      '&:last-child': {
        marginBottom: 0,
      },
    },
    segmentWrapper: {
      marginRight: theme.spacing(0.75),
      '&:last-child': {
        marginBottom: 0,
      },
    },
    segmentHeader: {
      marginBottom: theme.spacing(2),
      border: ' 1px solid #E5E7EB',
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08), 0px 1px 1px rgba(0, 0, 0, 0.08)',
      borderRadius: '24px',
      padding: theme.spacing(3, 0),
      [theme.breakpoints.down('xs')]: {
        border: 'none',
        boxShadow: 'none',
        padding: 0,
        marginBottom: theme.spacing(4),
      },
    },
    segmentTitle: {
      color: fade(theme.palette.grey[900], 0.65),
      marginRight: theme.spacing(1),
    },
    segmentCell: {
      height: theme.spacing(4.75),
      width: theme.spacing(7.25),
      borderRadius: theme.spacing(0.5),
      backgroundColor: theme.palette.assistant.assistant05,
      marginBottom: theme.spacing(0.75),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      color: fade(theme.palette.grey[900], 0.3),
      fontWeight: theme.typography.fontWeightMedium,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    selectedDay: {
      '& $segmentCell': {
        backgroundColor: fade(theme.palette.secondary.main, 0.05),
      },
    },
    avlSegmentCell: {
      backgroundColor: `${theme.palette.secondary.main} !important`,
      color: theme.palette.secondary.contrastText,
    },

    arrowRightIcon: {
      flexShrink: 0,
      width: theme.spacing(1.5),
      height: theme.spacing(1.5),
      '& path': {
        fill: theme.palette.secondary.main,
      },
    },
    underline: {
      textDecoration: 'underline',
    },
  }),
)

const BookingCard = ({ clinic, onOpenSchedule, newList, packages, first }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id } = useParams()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const { t } = useTranslation()
  const [days, setDays] = useState([])
  const [selectedDay, setSelectedDay] = useState('')
  const scrollRef = useRef(null)
  const isSpecial = clinic?.avlDoctorInfo?.isSpecial
  const getMaxAvlDays = () => {
    const startDay = subDays(new Date(), isSpecial ? -7 : -LATER_DISABLE_DAYS)
    const endDay = subMonths(new Date(), -AVAILABLE_MONTHS)
    return eachDayOfInterval({ start: startDay, end: endDay }) || []
  }

  useEffect(() => {
    if (!isMobile && first) {
      let date = new Date(first)
      let dayOfWeek = date.getDay()
      let month = date.getMonth() + 1
      dispatch(
        getAllTime({
          week: dayOfWeek,
          id: id,
          package: Number(packages),
        }),
      )
      onOpenSchedule?.({
        id: id,
        day: first,
        valueProgram: packages,
        month: month,
        week: dayOfWeek,
        // daySegment: Number(segment),
      })
    }
    const formatDays =
      getMaxAvlDays()?.map((day) => {
        const formatDay = format(day, DATE_FORMAT)
        const month = getMonth(day) + 1
        const date = getDate(day)
        const week = getDay(day)
        const avlDay = newList?.find((avlDay) => avlDay.day === formatDay)
        return {
          day: formatDay,
          month,
          date,
          week,
          ...avlDay,
        }
      }) || []
    // 可以选择的日期
    setSelectedDay(clinic?.avlDays?.[0]?.day)
    setDays([...formatDays])
  }, [clinic?.avlDays])

  const handleDatePickerChange = (day) => {
    if (day) {
      setSelectedDay(day)
    }
    // const index = days?.findIndex((item) => item.day === day)
    scrollRef.current?.scrollTo({
      top: 0,
      // left: index * 64,
      behavior: 'smooth',
    })
    const dayItem = days?.find((obj) => obj.day === day)
    if (dayItem) {
      dispatch(
        getAllTime({
          week: dayItem?.week,
          id: id,
          date: dayItem?.day,
          package: Number(packages),
        }),
      )
      onOpenSchedule?.({
        id: id,
        day,
        valueProgram: packages,
        month: dayItem?.month,
        week: dayItem?.week,
        // daySegment: Number(segment),
        status: Boolean(day),
      })
    }
    return day && setSelectedDay(day)
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.listWrapper}>
        <Box className={classes.segmentHeader}>
          {isMobile && (
            <Box fontSize="h4.fontSize" fontWeight={600} mb={1} pl={3}>
              {t('common.select_date')}
            </Box>
          )}

          <DatePicker2
            onChange={handleDatePickerChange}
            selectedDay={selectedDay}
            avlDays={newList}
            isMobile={isMobile}
          />
        </Box>{' '}
        {isMobile && <Divider style={{ marginBottom: theme.spacing(5) }} />}
      </Box>
    </Box>
  )
}

export default BookingCard
